const CATEGORY_TREE_STORAGE_KEY = 'category_tree';

/**
 * CategoryUtils
 * 
 * this class will provide the general method for category
 * 
 * - save / load data by local storage
 * - search category info by id 
 */

class CategoryUtils {
    // save data to localstorage
    static saveCategoryTree(tree) {
        localStorage.setItem(CATEGORY_TREE_STORAGE_KEY, JSON.stringify(tree));
    }

    // load data from localstorage
    static loadCategoryTree() {
        return JSON.parse(localStorage.getItem(CATEGORY_TREE_STORAGE_KEY));
    }

    // recursively search the tree by category id
    static searchTreeById(root, categoryId) {
        if (!root) {
            return null;
        }

        if (root.category.id === categoryId) {
            return root;
        }

        if (!categoryId.startsWith(root.category.id)) {
            //  Pruning branch, if not match in prefix, then just return null
            return null;
        }

        if (root.children && root.children.length > 0) {
            for (let index = 0; index < root.children.length; index++) {
                let cNode = root.children[index];
                let cResult = this.searchTreeById(cNode, categoryId);
                if (cResult) {
                    return cResult;
                }
            }
        }

        return null;
    }

    // recursively search the tree by category id
    // the label will include the ancestors label 
    static searchLabelFromTreeById(root, categoryId, prefix) {
        if (!root) {
            return '';
        }

        if (root.category.id === categoryId) {
            return prefix + root.category.displayTerm + '(' + root.category.term + ')';
        }

        if (!categoryId.startsWith(root.category.id)) {
            //  Pruning branch, if not match in prefix, then just return null
            return '';
        }

        if (root.children && root.children.length > 0) {
            if (root.category.id.length > 0) {
                // skip the `全部商品`
                prefix = prefix + root.category.displayTerm + '-';
            }

            for (let index = 0; index < root.children.length; index++) {
                let cNode = root.children[index];
                let cResult = this.searchLabelFromTreeById(cNode, categoryId, prefix);
                if (cResult && cResult.length > 0) {
                    return cResult;
                }
            }
        }

        return '';
    }

    // find the category by category id
    static findCategoryById(categoryId) {
        let tree = this.loadCategoryTree();
        let c = this.searchTreeById(tree, categoryId);
        return c;
    }

    // find the category label by category id
    static findCategoryLabelById(categoryId) {
        let tree = this.loadCategoryTree();
        let label = this.searchLabelFromTreeById(tree, categoryId, '');
        return label;
    }

    static convertCategoryLables(categoryIds) {
        let labels = [];

        categoryIds && categoryIds.forEach((id) => {
            const label = this.findCategoryLabelById(id);
            if (label && label.length > 0) {
                labels.push(id + '-' + label);
            }
        });
        return labels;
    }

    static categoryCNById(categoryIds) {
        if (categoryIds && categoryIds.length) {
            let categoryCN = this.convertCategoryLables(categoryIds).join(' | ');
            return categoryCN;
        }
        return '';
    }
}

export default CategoryUtils;